import { useMemo } from 'react'
import { getPayPalKey } from 'stores/paymentStore/payment.utils'
import PaymentManager from 'services/PaymentManager'
import { useLanguage } from 'services/LangProvider'
import { isServer } from 'utils/runtimeUtils'
import { usePricing } from 'components/Pricing/PricingProvider'

export default function usePayPalOptions() {
  const language = useLanguage()
  const { pricingData } = usePricing()
  const paypalClientId = isServer()
    ? ''
    : getPayPalKey(PaymentManager.getPayPalAccountName())

  const currency = pricingData.currency

  const getPayPalLocale = () => {
    // PayPal locale format: language_COUNTRY (e.g., en_US, es_ES, fr_FR, de_DE)
    const paypalLocaleMap: Record<string, string> = {
      en: 'en_US',
      es: 'es_ES',
      fr: 'fr_FR',
      de: 'de_DE',
    }
    return paypalLocaleMap[language] || 'en_US'
  }

  const options = useMemo(
    () => ({
      clientId: paypalClientId,
      currency,
      locale: getPayPalLocale(),
      disableFunding:
        'credit,card,sofort,mybank,venmo,sepa,bancontact,eps,giropay,ideal,p24',
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [paypalClientId, currency, language]
  )

  return options
}
